<template>
    <div :class="wrapperClasses">
        <div class="between-center">
            <div>
                <h4 class="title subheading is-4">
                    Contacts
                    <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                        <o-icon pack="fa" icon="gear" size="is-small"/>
                    </a>
                </h4>
            </div>
            <p v-if="checkedRows.length" class="control">
                <a @click.prevent="confirmCustomDelete" class="button is-danger">Delete Contacts</a>
            </p>
        </div>
        <o-table
            class="company-width-table is-responsive is-responsive-desktop"

            v-if="isTableVisible"
            :data="companyContacts"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :loading="table.loading"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :per-page="table.perPage"
            :pagination-simple="table.paginationSimple"
            :default-sort="[hasColumn('full_name') ? 'full_name' : 'first_name', 'asc']"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"
        >
            <templat>
                <template>
                    <div  v-for="col in tableColumns">
                      <o-table-column
                          :field="col.field"
                          :label="col.field === 'actions' ? '' : col.label"
                          :key="col.field"
                          #default="{ row }"
                          :sortable="col.sortable"
                      >
                        <router-link v-if="col.field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                          {{ userNameById(row.last_editor_id) }}
                        </router-link>

                        <router-link v-if="col.field === 'company_id'" :to="{ name: 'companies.show', params: { slug: row.company_id } }">
                          {{ row.company_name }}
                        </router-link>

                        <content-editable v-if="col.field === 'first_name'" :entity="row" field="first_name" :update="partialUpdateContact"/>
                        <content-editable v-if="col.field === 'last_name'" :entity="row" field="last_name" :update="partialUpdateContact"/>
                        <span v-if="col.field === 'full_name'">{{ row.full_name }}</span>
                        <span v-if="col.field === 'telephone'">{{  $filters.valueOrDefault(row.telephone) }}</span>
                        <span v-if="col.field === 'mobile'">{{  $filters.valueOrDefault(row.mobile) }}</span>
                        <span v-if="col.field === 'email'">{{  $filters.valueOrDefault(row.email) }}</span>
                        <span v-if="col.field === 'fax'">{{  $filters.valueOrDefault(row.fax) }}</span>
                        <span v-if="col.field === 'title'">{{ row.title }}</span>
                        <span v-if="col.field === 'address_1'">{{ $filters.valueOrDefault($filters.contactAddress(row)) }}</span>
                        <span v-if="col.field === 'zip'">{{ $filters.valueOrDefault(row.zip)  }}</span>
                        <span v-if="col.field === 'created_at'">{{ row.created_at | date }}</span>
                        <span v-if="col.field === 'lead_owner'">{{ $filters.valueOrDefault(userNameById(row.lead_owner)) }}</span>
                        <span v-if="col.field === 'formatted_licenses'" class="formatted-license" v-html="row.formatted_licenses"></span>
                        <span v-if="col.field === 'created_at'">{{  $filters.datetime(row.created_at) }}</span>
                        <span v-if="col.field === 'updated_at'">{{  $filters.datetime(row.updated_at) }}</span>

                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                          <template v-slot:trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                          <o-dropdown-item has-link><a @click="openViewContactModal(row)">View</a></o-dropdown-item>
                          <o-dropdown-item has-link><a @click="openContactModal(row)">Edit</a></o-dropdown-item>
                          <o-dropdown-item has-link><a @click.prevent="handleRemove(row)">Delete</a></o-dropdown-item>
                        </o-dropdown>
                      </o-table-column>
                    </div>
                </template>
            </templat>

          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isViewContactModalActive" has-modal-card>
            <view-contact-modal :contact="currentContact"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactModalActive" has-modal-card>
            <contact-modal :edit-mode="true" :item="currentContact"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
import ViewContactModal from '../../../components/modals/ViewContact';
import Table from '../../../mixins/Table';

    export default {
        mixins: [Table],

        props: {
            referenceId: {
                type: Number
            },
            referenceType: {
                type: String
            },
            isModal: {
                type: Boolean,
                default: false
            }
        },

        components: {
            ViewContactModal,
        },

        data () {
            return {
                tableName: 'contacts-index',
                currentContact: null,
                isContactModalActive: false,
                isViewContactModalActive: false
            }
        },

        mounted () {
            this.fetchContacts({
                company_id: this.referenceId
            }).then(res => {
                let contactId = this.$route.query.contact_id
                if (contactId) {
                    this.currentContact = this.contactById(parseInt(contactId))
                    this.isViewContactModalActive = true
                }
                return res
            })


        },

        methods: {
            ...mapActions({
                removeItem: 'removeContact',
                fetchContacts: 'fetchContacts',
                partialUpdateContact: 'partialUpdateContact'
            }),

            openViewContactModal (contact) {
                this.currentContact = contact
                this.isViewContactModalActive = true
            },

            openContactModal (contact) {
                this.currentContact = contact
                this.isContactModalActive = true
            },

            handleRemove(contact) {
                this.confirmMessage(
                    'Deleting Contact',
                    'Are you sure you want to <strong>delete</strong> this contact? This action cannot be undone.',
                    'Delete Contact'
                ).then(() => {
                    this.removeItem(contact)
                        .then(() => this.successMessage('Contact have been deleted'))
                })
            }
        },

        computed: {
            ...mapGetters(['contactsByCompanyId', 'contactById', 'companyNameById', 'userNameById']),

            companyContacts() {
                return this.contactsByCompanyId(this.companyId)
            },

            companyId() {
                return this.referenceId
            },

            wrapperClasses() {
                return this.isModal
                    ? 'column is-12'
                    : 'column is-12 is-9-hd is-9-hd-wide is-9-hd-plus'
            }
        }
    }
</script>
